import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'

Vue.use(ElementUI);
Vue.prototype.$axios = axios;


/* swiper */
import 'swiper/css/swiper.min.css';

/* bootstrap 样式*/
import 'bootstrap/dist/css/bootstrap.min.css'

/* 字体 */
import 'font-awesome/css/font-awesome.min.css'

/* 重置样式 */
import './assets/css/reset.css'

/* jquery引入*/
import $ from 'jquery'

import 'swiper/js/swiper.min.js';

/* bootstrap js引入*/
import 'bootstrap/dist/js/bootstrap.min.js'

/* animate.css */
import 'animate.css'

/* 头部组件 */
import Ceiling from './components/Ceiling'
Vue.component(Ceiling.name,Ceiling)

/* 尾部组件 */
import Bottom from './components/Bottom'
Vue.component(Bottom.name,Bottom)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

// 引入echarts
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if(to.meta.title){
    document.title = to.meta.title
  }
  next();
});
// 跳转后返回顶部
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
